// Passing and failing measures per severity (Security KPI "Overall security measures", product owner 2026-10-22):
// one small stacked bar per severity, critical to low, with the counts in words beside the severity. The bars are
// decoration (aria-hidden) and their lengths share one scale (the largest severity), so rows compare by size; the
// words carry every count. Status colors are only the bar segments and never the text (amber is never a text color).
// The segments use the muted bar fills (--bar-*, src/styles.css), 3:1 on the track, not the brighter dot colors.

export const SEGMENTS = Object.freeze([
  ['pass', 'var(--bar-pass)'],
  ['warn', 'var(--bar-warn)'],
  ['fail', 'var(--bar-fail)'],
]);

const words = (r) => [
  `${r.pass} passed`,
  r.warn > 0 ? `${r.warn} ${r.warn === 1 ? 'warning' : 'warnings'}` : null,
  `${r.fail} failed`,
].filter(Boolean).join(', ');

/** @param {{ rows: Array<{ severity: string, word: string, pass: number, warn: number, fail: number, total: number }> }} props */
export default function MeasureBars({ rows }) {
  const list = Array.isArray(rows) ? rows : [];
  const scale = Math.max(1, ...list.map((r) => r.total));
  return (
    <ul className="space-y-2" aria-label="Measures by severity" data-testid="measure-bars">
      {list.map((r) => (
        <li key={r.severity} data-severity={r.severity}>
          <div className="flex items-baseline justify-between gap-2 text-[13px]">
            <span className="font-semibold text-ipc-ink">{r.word}</span>
            <span className="tabular-nums text-ipc-muted" data-measure-words="">{words(r)}</span>
          </div>
          <div className="mt-1 flex h-2 w-full overflow-hidden" style={{ background: 'var(--kpi-track)' }} aria-hidden="true">
            {SEGMENTS.map(([key, color]) => (r[key] > 0 ? (
              <span key={key} className="block h-full" style={{ width: `${(r[key] / scale) * 100}%`, background: color }} data-segment={key} />
            ) : null))}
          </div>
        </li>
      ))}
    </ul>
  );
}
